import type { TrackingStep } from "../api";

// Testo sempre nero (Davide 23/09): il passaggio lo dice il colore del fondo.
// «In giacenza» e' rosso come la restituzione: il pacco e' fermo in filiale e
// qualcuno deve muoversi, o torna indietro. «Non tracciata» ha il bordo
// tratteggiato per non confondersi con «Presa in carico».
const STEP_BADGE_CLASS: Record<TrackingStep, string> = {
  "Presa in carico": "bg-paper border-line-2",
  "In transito": "bg-blue-soft border-blue/20",
  "In consegna": "bg-amber-soft border-amber/20",
  "In giacenza": "bg-red-soft border-red/20",
  Consegnata: "bg-green-soft border-green/20",
  "In restituzione": "bg-red-soft border-red/20",
  // Il ritorno al mittente (26/10, Davide: «voglio sia segnalato in rosso»):
  // bordo rosso pieno e grassetto, deve spiccare anche fra le giacenze.
  "Ritorno al mittente": "bg-red-soft border-red font-bold",
  "Rientrata al mittente": "bg-red-soft border-red font-bold",
  "": "bg-card border-dashed border-line-2",
};

/** Badge colorato del passaggio di tracking (spedizione, collo o evento). */
export function StepBadge({ step, small = false }: { step: TrackingStep; small?: boolean }) {
  return (
    <span
      className={[
        "inline-flex shrink-0 items-center rounded-full border text-ink",
        STEP_BADGE_CLASS[step]?.includes("font-bold") ? "" : "font-medium",
        small ? "px-1.5 py-0 text-[9.5px]" : "px-2.5 py-0.5 text-[11px]",
        STEP_BADGE_CLASS[step] ?? STEP_BADGE_CLASS[""],
      ].join(" ")}
    >
      {step || "Non tracciata"}
    </span>
  );
}
